// src/pages/FounderDetails.jsx
import React from "react";
import img5 from "../about/image copy.png";

const FounderDetails = () => {
  return (
    <div className="bg-white min-h-screen px-6 sm:px-10 md:px-24 py-16 text-black">
      <div className="max-w-5xl mx-auto text-center">
        {/* Founder Image */}
        <img
          src={img5}
          alt="Founder"
          className="w-60 h-60 object-cover rounded-full mx-auto shadow-lg mb-8"
        />
        <h1 className="text-4xl sm:text-5xl font-extrabold mb-4">
          R. S. Jeyapaul
        </h1>
        <h2 className="text-xl text-gray-600 mb-6">
          Founder & Managing Director, Twin Star Industries
        </h2>
      </div>

      {/* Tamil Content */}
      <div className="max-w-5xl mx-auto mb-16">
        <h2 className="text-2xl font-bold mb-4">மூலதன மேலாளர் பயணம்</h2>
        <p className="text-lg text-gray-700 leading-relaxed mb-4">
          தாழ்மையான பின்னணியிலிருந்து இந்தியாவின் நம்பிக்கைக்குரிய ஆட்டோமொபைல்
          ஃபாஸ்டனர் உற்பத்தி நிறுவனத்தை வழிநடத்தும் நிலைக்கு வருவதற்கு, திரு.
          ஆர்.எஸ். ஜெயபாலின் வாழ்க்கைப் பயணம் கடுமையான உழைப்பு, தெளிவான பார்வை
          மற்றும் உறுதியான விருப்பத்தின் கதையாகும்.
        </p>

        <h3 className="text-xl font-semibold mb-2">தொடக்க வாழ்க்கை மற்றும் பின்னணி</h3>
        <p className="text-lg text-gray-700 leading-relaxed mb-4">
          தொழிலாளி குடும்பத்தில் பிறந்த ஜெயபால் அவர்களுக்கு வாழ்க்கையின்
          ஆரம்பத்திலேயே ஒழுக்கம் மற்றும் பொறுப்பு என்னும் மதிப்பீடுகள்
          விதைக்கப்பட்டன. பொருளாதாரத் தடைகளை மீறியும், கல்வியின் மீது வைத்திருந்த
          ஆர்வம் மற்றும் பொறியியல் துறையின் மீது கொண்ட ஆர்வம் அவரை வழிநடத்தியது.
        </p>

        <h3 className="text-xl font-semibold mb-2">Twin Star Industries -ன் தொடக்கம்</h3>
        <p className="text-lg text-gray-700 leading-relaxed mb-4">
          தனக்கே உரிய தொழில் ஒன்றை தொடங்கி, நாட்டின் உற்பத்தித் துறையில் ஒரு தடம்
          பதிக்க வேண்டும் என்ற கனவுடன், திரு. ஜெயபால் சில இயந்திரங்கள் மற்றும்
          சிலர் கொண்ட குழுவுடன் Twin Star Industries-ஐ நிறுவினார். ஆரம்பத்தில்
          சில அடிப்படை ஃபாஸ்டனர் தயாரிப்புகளுடன் ஆரம்பித்தார்.
        </p>

        <h3 className="text-xl font-semibold mb-2">சவால்களை கடந்து வெற்றிக்கான பாதை</h3>
        <p className="text-lg text-gray-700 leading-relaxed mb-4">
          வழக்கமான வேலை நேரங்களை மீறியும், இரவு நேரங்களிலும் வேலை செய்து, சிறிய
          குழுவுடன் ஒவ்வொரு ஆர்டரையும் நேரத்தில் முடித்து கொடுத்தார். சில நேரங்களில்
          அவரே வாடிக்கையாளர்களிடம் நேரில் சென்று தயாரிப்புகளை வழங்கிய
          நிகழ்வுகளும் இருந்துள்ளன. ஒரு முக்கிய வாடிக்கையாளரிடமிருந்து பெற்ற முதல்
          பெரிய ஒப்பந்தம் அவரின் வாழ்க்கையில் திருப்புமுனையாக இருந்தது.
        </p>

        <h3 className="text-xl font-semibold mb-2">வளர்ச்சி மற்றும் அங்கீகாரம்</h3>
        <p className="text-lg text-gray-700 leading-relaxed mb-4">
          இன்று Twin Star Industries, மாருதி சுசுகி உள்ளிட்ட முன்னணி வாகன
          உற்பத்தியாளர்களுக்கு தரமான கூறுகளை வழங்கும் நம்பிக்கைக்குரிய நிறுவனம் ஆக
          வளர்ந்துள்ளது. ISO தரச்சான்றுகள், திறமையான பணியாளர்கள் மற்றும் நவீன
          உற்பத்தி வசதிகள் இந்த வளர்ச்சியின் அடிப்படையாக உள்ளன.
        </p>

        <h3 className="text-xl font-semibold mb-2">தத்துவம் மற்றும் எதிர்காலக் கனவு</h3>
        <p className="text-lg text-gray-700 leading-relaxed mb-4">
          திரு. ஜெயபாலுக்கு வணிகம் என்பது வெறும் லாபத்திற்காக அல்ல — அது மக்கள்,
          நோக்கம் மற்றும் முன்னேற்றம் என்பவற்றைக் கொண்டதாக இருக்க வேண்டும் என்பதே
          அவரது நம்பிக்கை. இன்னும் பல புதிய சந்தைகளில் விரிவடையுதல், பரபரப்பான
          உற்பத்தி பங்களிப்புகள் மற்றும் பரம்பரை தலைமுறை வளர்ச்சி என அவரது
          எதிர்காலத் திட்டங்கள் தெளிவாக உள்ளது.
        </p>

        <blockquote className="border-l-4 border-blue-600 pl-4 italic text-gray-800 mt-6">
          "ஒவ்வொரு சவாலும் வளர்ச்சிக்கு ஒரு வாய்ப்பாகவே நான் பார்த்தேன். இந்த
          பயணம் எனது கனவையே பிரதிபலிக்கிறது — மனப்பூர்வமான நோக்கம், நேர்மையான
          முயற்சி மற்றும் நெடுநேர கற்றல் ஆகியவை ஒன்றாகச் சேர்ந்தால்தான் வெற்றி
          கிடைக்கும்."
          <br />— ஆர்.எஸ். ஜெயபால்
        </blockquote>
      </div>

      {/* English Content */}
      <div className="max-w-5xl mx-auto">
        <h2 className="text-2xl font-bold mb-4">Managing Director’s Journey</h2>
        <p className="text-lg text-gray-700 leading-relaxed mb-4">
          From humble beginnings to leading one of the trusted names in automotive
          fastener manufacturing, Mr. R.S. Jeyapaul’s journey is a story of
          resilience, vision, and relentless hard work.
        </p>

        <h3 className="text-xl font-semibold mb-2">Early Life & Background</h3>
        <p className="text-lg text-gray-700 leading-relaxed mb-4">
          Born into a modest family with strong values and work ethic, Mr.
          Jeyapaul learned early on the importance of discipline and perseverance.
          Though financial resources were limited, his thirst for learning and
          passion for engineering set the foundation for a purposeful life.
        </p>

        <h3 className="text-xl font-semibold mb-2">The Beginning of Twin Star Industries</h3>
        <p className="text-lg text-gray-700 leading-relaxed mb-4">
          Driven by a dream to create something of his own, Mr. Jeyapaul founded
          Twin Star Industries with just a few machines and a small team.
          Starting with basic fastener manufacturing, he faced immense challenges
          — from limited working capital to equipment breakdowns and client
          acquisition.
        </p>

        <h3 className="text-xl font-semibold mb-2">Growth & Recognition</h3>
        <p className="text-lg text-gray-700 leading-relaxed mb-4">
          Today, Twin Star Industries is a trusted vendor for Maruti Suzuki and
          other major automotive OEMs. The company operates with modern
          infrastructure, skilled manpower, and ISO-certified standards.
        </p>

        <h3 className="text-xl font-semibold mb-2">Philosophy & Future Vision</h3>
        <p className="text-lg text-gray-700 leading-relaxed mb-4">
          For Mr. Jeyapaul, business is not just about profit — it’s about people,
          purpose, and progress. Looking ahead, his focus is on expanding into new
          markets, embracing sustainability, and nurturing the next generation of
          leaders.
        </p>

        <blockquote className="border-l-4 border-blue-600 pl-4 italic text-gray-800 mt-6">
          “Every challenge is an opportunity to grow. My journey is a reflection
          of what’s possible when you believe in your purpose, stay honest in
          your efforts, and never stop learning.”
          <br />— R.S. Jeyapaul
        </blockquote>
      </div>
    </div>
  );
};

export default FounderDetails;
